import {Bar, BarChart, CartesianGrid, Cell, Legend, Pie, PieChart, Sector, Tooltip, XAxis, YAxis} from "recharts";
import React, {useEffect, useRef, useState} from "react";

export default function BarGraph(props) {
    const [width, setWidth] = useState(0);
    const [height, setHeight] = useState(0);
    const elementRef = useRef(null);
    useEffect(() => {

        setWidth(elementRef.current.getBoundingClientRect().width);
        setHeight(elementRef.current.getBoundingClientRect().height);
    }, []);
    return (
        <div
            className="w-full px-2 my-2  h-72 text-center mb-10" ref={elementRef}>
            <div className={"text-2xl pb-2 mb-4 "}>
                {props.name}
            </div>
            {!props.Statistic ?
                <div role="status"
                     className="p-4 max-w-sm rounded border border-gray-200 shadow animate-pulse md:p-6 dark:border-gray-700 w-96">
                    <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-32 mb-2.5"></div>
                    <div className="mb-10 w-48 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                    <div className="flex items-baseline mt-4 space-x-6">
                        <div className="w-full h-8 bg-gray-200 rounded-t-lg dark:bg-gray-700"></div>
                        <div className="w-full h-20 bg-gray-200 rounded-t-lg dark:bg-gray-700"></div>
                        <div className="w-full h-24 bg-gray-200 rounded-t-lg dark:bg-gray-700"></div>
                        <div className="w-full h-16 bg-gray-200 rounded-t-lg dark:bg-gray-700"></div>
                        <div className="w-full h-14 bg-gray-200 rounded-t-lg dark:bg-gray-700"></div>
                        <div className="w-full h-8 bg-gray-200 rounded-t-lg dark:bg-gray-700"></div>
                        <div className="w-full h-24 bg-gray-200 rounded-t-lg dark:bg-gray-700"></div>
                    </div>
                    <span className="sr-only">Loading...</span>
                </div>
                :
                <BarChart
                    width={width}
                    height={height}
                    data={props.Statistic}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}
                    barSize={40}
                >
                    <XAxis dataKey="name" scale="point" padding={{left: 30, right: 30}}/>
                    <YAxis/>
                    <Tooltip/>
                    <Legend/>
                    <CartesianGrid strokeDasharray="3 3"/>
                    <Bar dataKey="total" fill="#8884d8" background={{fill: '#eee'}}/>
                </BarChart>
            }
        </div>

    )
}

export function BarGraphOutside(props) {
    return (
        <div
            className="w-full px-2 my-2  h-72 text-center mb-10">
            <div className={"text-2xl pb-2 mb-4 "}>
                {props.name}
            </div>
            {!props.Statistic ?
                <div role="status"
                     className="p-4 max-w-sm rounded border border-gray-200 shadow animate-pulse md:p-6 dark:border-gray-700 w-96">
                    <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-32 mb-2.5"></div>
                    <div className="mb-10 w-48 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                    <div className="flex items-baseline mt-4 space-x-6">
                        <div className="w-full h-8 bg-gray-200 rounded-t-lg dark:bg-gray-700"></div>
                        <div className="w-full h-20 bg-gray-200 rounded-t-lg dark:bg-gray-700"></div>
                        <div className="w-full h-24 bg-gray-200 rounded-t-lg dark:bg-gray-700"></div>
                        <div className="w-full h-16 bg-gray-200 rounded-t-lg dark:bg-gray-700"></div>
                        <div className="w-full h-14 bg-gray-200 rounded-t-lg dark:bg-gray-700"></div>
                        <div className="w-full h-8 bg-gray-200 rounded-t-lg dark:bg-gray-700"></div>
                        <div className="w-full h-24 bg-gray-200 rounded-t-lg dark:bg-gray-700"></div>
                    </div>
                    <span className="sr-only">Loading...</span>
                </div>
                :
                <BarChart
                    width={props.width}
                    height={props.height}
                    data={props.Statistic}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}
                    barSize={40}
                >
                    <XAxis dataKey="name" scale="point" padding={{left: 30, right: 30}}/>
                    <YAxis/>
                    <Tooltip/>
                    <Legend/>
                    <CartesianGrid strokeDasharray="3 3"/>
                    <Bar dataKey="total" fill="#8884d8" background={{fill: '#eee'}}/>
                </BarChart>
            }
        </div>

    )
}

export function PieGraphOutside(props) {
    const [activeIndex, setActiveIndex] = useState(0);
    const renderActiveShape = (props) => {
        const RADIAN = Math.PI / 180;
        const {cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent, value} = props;
        const sin = Math.sin(-RADIAN * midAngle);
        const cos = Math.cos(-RADIAN * midAngle);
        const sx = cx + (outerRadius + 10) * cos;
        const sy = cy + (outerRadius + 10) * sin;
        const mx = cx + (outerRadius + 30) * cos;
        const my = cy + (outerRadius + 30) * sin;
        const ex = mx + (cos >= 0 ? 1 : -1) * 22;
        const ey = my;
        const textAnchor = cos >= 0 ? 'start' : 'end';

        return (
            <g>
                <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
                    {payload.name}
                </text>
                <Sector
                    cx={cx}
                    cy={cy}
                    innerRadius={innerRadius}
                    outerRadius={outerRadius}
                    startAngle={startAngle}
                    endAngle={endAngle}
                    fill={fill}
                />
                <Sector
                    cx={cx}
                    cy={cy}
                    startAngle={startAngle}
                    endAngle={endAngle}
                    innerRadius={outerRadius + 6}
                    outerRadius={outerRadius + 10}
                    fill={fill}
                />
                <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none"/>
                <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none"/>
                <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor}
                      fill="#333">{`Jumlah ${value}`}</text>
                <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} fill="#999">
                    {`(Rate ${(percent * 100).toFixed(2)}%)`}
                </text>
            </g>
        );
    };
    const onPieEnter = (_, index) => {
        setActiveIndex(index)

    };
    const COLORS = ['#0088FE', '#FF8042', '#00C49F', '#FFBB28',];
    let dataPie = []

    if (props.Statistic) {
        dataPie = [
            {
                name: "Pria",
                value: parseInt(props.Statistic[1].total)
            },
            {
                name: "Wanita",
                value: parseInt(props.Statistic[0].total)
            }

        ]
    }


    return (
        <div
            className="w-full px-2 my-2  h-72 text-center mb-10">
            <div className={"text-2xl pb-2 mb-4 "}>
                {props.name}
            </div>
            {!props.Statistic ?
                <div role="status"
                     className="p-4 max-w-sm rounded border border-gray-200 shadow animate-pulse md:p-6 dark:border-gray-700 w-96">
                    <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-32 mb-2.5"></div>
                    <div className="mb-10 w-48 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                    <div className="flex items-baseline mt-4 space-x-6">
                        <div className="w-full h-8 bg-gray-200 rounded-t-lg dark:bg-gray-700"></div>
                        <div className="w-full h-20 bg-gray-200 rounded-t-lg dark:bg-gray-700"></div>
                        <div className="w-full h-24 bg-gray-200 rounded-t-lg dark:bg-gray-700"></div>
                        <div className="w-full h-16 bg-gray-200 rounded-t-lg dark:bg-gray-700"></div>
                        <div className="w-full h-14 bg-gray-200 rounded-t-lg dark:bg-gray-700"></div>
                        <div className="w-full h-8 bg-gray-200 rounded-t-lg dark:bg-gray-700"></div>
                        <div className="w-full h-24 bg-gray-200 rounded-t-lg dark:bg-gray-700"></div>
                    </div>
                    <span className="sr-only">Loading...</span>
                </div>
                :
                <PieChart width={props.width}
                          height={props.height}
                >
                    <Pie
                        activeIndex={activeIndex}
                        activeShape={renderActiveShape}
                        data={dataPie}
                        cx="50%"
                        cy="50%"
                        innerRadius={30}
                        outerRadius={80}
                        fill="#8884d8"
                        dataKey="value"
                        onMouseEnter={onPieEnter}

                    >
                        {dataPie.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]}/>
                        ))}
                    </Pie>
                </PieChart>
            }
        </div>

    )
}